import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_NOTES_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeNotesArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_NOTES } from '../redux/action-types'

const useUpdateDishTypeNotesMutation = () => {
  const dispatch = useDispatch()

  const { isNotesLoading, notesError } = useSelector(
    store => store.dishTypes.dishType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_NOTES_MUTATION,
        { id, data: transformToUpdateDishTypeNotesArgs(data) },
        dispatch,
        UPDATE_DISH_TYPE_NOTES,
      ),
    [dispatch],
  )

  return [mutate, { isLoading: isNotesLoading, error: notesError }]
}

export default useUpdateDishTypeNotesMutation
